<template>
    <div>
        <b-modal size="xl" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">
            <b-form @submit.prevent="updateManual" enctype="multipart/form-data">
                <b-card>
                    <b-form-row>
                        <b-form-group label-for="textarea-formatter" class="col-12" pd="12">
                            <label for="textarea-auto-height">Descrição: *</label>
                            <b-form-textarea id="textarea-formatter" v-model="form.descricao" :required="true"
                                :disabled="disabled">
                            </b-form-textarea>
                        </b-form-group>
                        <b-form-group label="Situação:" class="text-left">
                            <b-form-radio-group :disabled="disabled" v-model="form.situacao" class="d-inline-block">
                                <b-form-radio :value="1">Ativo</b-form-radio>
                                <b-form-radio :value="0">Inativo</b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                        <b-col lg="12" sm="12" class="text-right">
                            <div>
                                <label for="fileInput" class="file-input-label cursor-pointer">
                                    <div class="d-flex align-items-center">
                                        <clip-img-comp id="clip"></clip-img-comp>
                                    </div>
                                </label>
                                <input type="file" id="fileInput" ref="fileInput" multiple @change="handleFileChange"
                                    style="display: none" :disabled="disabled" />
                                <b-tooltip :disabled="disabled" :target="'clip'"
                                    title="Adicionar Arquivos..."></b-tooltip>
                            </div>
                        </b-col>
                    </b-form-row>
                </b-card>
            </b-form>
            <b-card bg-variant="light">
                <b-table responsive class="mt-2 table-hover link-style" small :busy="this.busy"
                    :items="this.form.itemRepositorioDocumento" :fields="this.tableFields" :hover="true" show-empty
                    @row-clicked="showDocument">
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>

                    <template v-slot:cell(remover)="row">
                        <b-button :id="row.index + 'delete-button'" class="my-2" size="sm" pill variant="primary"
                            @click="deletarDocumento(row.item)" :disabled="disabled">
                            <b-icon icon="trash" />
                            <b-tooltip :target="row.index + 'delete-button'" title="Remover..."></b-tooltip>
                        </b-button>
                    </template>

                    <template #empty>
                        <h6 style="text-align: center">Nenhum item vinculado</h6>
                    </template>
                </b-table>

                <div class="d-flex justify-content-center align-items-center w-100">
                    <b-button type="submit" variant="success" style="height: 20px" size="sm" pill @click="save"
                        :disabled="disabled">
                        <div class="btn-size-alinhamento">
                            <b-icon icon="check-circle" />
                        </div>
                    </b-button>

                    <b-button class="ml-2" @click="cancelar" variant="danger" style="height: 20px" size="sm" pill>
                        <div class="btn-size-alinhamento">
                            <b-icon icon="x-circle" />
                        </div>
                    </b-button>
                </div>
            </b-card>
        </b-modal>

        <b-modal v-model="showPdfViewer" size="xl" hide-footer title="Visualizar Documento" @hidden="closePdfViewer">
            <div style="height: 75vh;">
                <iframe v-if="pdfBlobUrl" :src="pdfBlobUrl" width="100%" height="100%" style="border: none;"></iframe>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { ListResourceMixin } from "@/core/mixins/resource"
import ClipImgComp from "@/components/Svgs/ClipImg.vue"
import required from "vuelidate/lib/validators/required"
import ManuaisRoteirosAtosService from "@/core/api/ManuaisRoteirosAtosService"
import ItemRepositorioDocumentoService from "@/core/api/ItemRepositorioDocumentoService"
import DownloadArquivoUtil from "@/core/utils/DownloadArquivoUtil"

export default {
    components: { ClipImgComp },

    props: {
        prefix: {
            type: String,
            default: "Manuais, Roteiros e Atos > ",
        },
        title: {
            type: String,
            default: "Cadastro",
        },
        id: {
            type: Number,
            default: null,
        },
        isBusy: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    validations: {
        form: {
            descricao: { required },
            situacao: { required },
        },
    },

    data() {
        return {
            showModal: true,
            form: {
                descricao: "",
                data: new Date().toISOString(),
                usuario: "Administrador Senado",
                usuarioId: 1,
                situacao: 1,
                itemRepositorioDocumento: [],
            },
            files: [],
            showPdfViewer: false,
            pdfBlobUrl: null,
            loadingDocumento: false,
        }
    },

    mixins: [ListResourceMixin],

    async beforeMount() {
        this.$ManuaisRoteirosAtosService = new ManuaisRoteirosAtosService()
        this.$ItemRepositorioDocumentoService =
            new ItemRepositorioDocumentoService()
    },

    async mounted() {
        if (this.id) {
            await this.$ManuaisRoteirosAtosService
                .findById(this.id)
                .then(response => {
                    this.form = response.data
                })
                .finally(() => {
                    this.busy = false
                })
        } else {
            this.busy = false
        }
    },

    watch: {
        page() {
            this.load()
        },
    },

    computed: {
        formIsValid() {
            return !this.$v.$invalid
        },

        tableFields() {
            return [
                { key: "nomeDocumento", label: "Arquivo" },
                { key: "remover", label: "", tdClass: "w-4" },
            ]
        },
    },

    methods: {
        async save() {
            if (!this.formIsValid) {
                this.$v.$touch()
                this.$notify({
                    type: "danger",
                    message: "Verifique os campos do cadastro.",
                })
                return
            }
            this.busy = true
            let vm = this
            this.$ManuaisRoteirosAtosService.save(this.form).then(() => {
                vm.busy = false
                vm.$notify({
                    type: "success",
                    message: "Registro salvo com sucesso",
                })
                this.$emit("update:showModal", false)
                this.$emit("close")
            })
        },

        async load() {
            await this.$ManuaisRoteirosAtosService
                .findById(this.id)
                .then(response => {
                    this.records = response.data
                })
                .finally(() => {
                    this.busy = false
                })
        },

        limpar() {
            this.form.itemRepositorio = []
        },

        handleFileChange(event) {
            const files = event.target.files
            this.convertToBase64(files)
        },

        deletarDocumento(item) {
            this.form.itemRepositorioDocumento =
                this.form.itemRepositorioDocumento.filter(
                    itemRepositorioDocumento => itemRepositorioDocumento.id !== item.id
                )
        },

        cancelar() {
            this.$emit("close")
        },

        async showDocument(item) {
            const isPdf = item.nomeDocumento && item.nomeDocumento.toLowerCase().endsWith('.pdf')

            if (item.id) {
                this.loadingDocumento = true
                try {
                    let id = item.id
                    const response = await this.$ItemRepositorioDocumentoService.findById(id)
                    let arquivo = response.data.arquivoBase64
                    let nome = response.data.nomeDocumento

                    if (nome && nome.toLowerCase().endsWith('.pdf')) {
                        this.openPdfViewer(arquivo)
                    } else {
                        DownloadArquivoUtil(arquivo, nome)
                    }
                } catch (error) {
                    this.$notify({
                        type: "danger",
                        message: "Erro ao carregar o documento",
                    })
                } finally {
                    this.loadingDocumento = false
                }
            } else {
                if (isPdf) {
                    this.openPdfViewer(item.arquivo)
                } else {
                    DownloadArquivoUtil(item.arquivo, item.nomeDocumento)
                }
            }
        },

        openPdfViewer(base64Data) {
            const binaryString = window.atob(base64Data)
            const len = binaryString.length
            const bytes = new Uint8Array(len)
            for (let i = 0; i < len; i++) {
                bytes[i] = binaryString.charCodeAt(i)
            }
            const blob = new Blob([bytes], { type: 'application/pdf' })
            this.pdfBlobUrl = URL.createObjectURL(blob)
            this.showPdfViewer = true
        },

        closePdfViewer() {
            if (this.pdfBlobUrl) {
                URL.revokeObjectURL(this.pdfBlobUrl)
                this.pdfBlobUrl = null
            }
            this.showPdfViewer = false
        },

        convertToBase64(files) {
            const promises = Array.from(files).map(file => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader()
                    reader.onload = () => {
                        const base64Data = reader.result.split(",")[1]
                        const fileName = file.name
                        resolve({ base64Data, fileName })
                    }
                    reader.onerror = error => reject(error)
                    reader.readAsDataURL(file)
                })
            })

            Promise.all(promises)
                .then(base64Array => {
                    base64Array.map(b64A => {
                        this.form.itemRepositorioDocumento.push({
                            arquivo: b64A.base64Data,
                            nomeDocumento: b64A.fileName,
                        })
                    })
                })
                .catch(error => {
                    this.$notify({
                        type: "danger",
                        message: error,
                    })
                })
        },
    },
}
</script>
<style>
.link-style td {
    color: #0a2c4e !important;
    font-weight: 500;
    cursor: pointer;
    text-decoration: underline;
}

.cursor-pointer {
    cursor: pointer;
}
</style>
